'use client';

import type { ReactElement } from 'react';
import styles from './Loading.module.scss';

type LoadingProps = {
  message?: string;
  className?: string;
};

export default function Loading({
  message = 'Loading...',
  className = '',
}: LoadingProps): ReactElement {
  return (
    <div
      aria-label="Loading"
      aria-live="polite"
      className={`${styles.loadingContainer} ${className}`}
      role="status"
    >
      <span className={styles.circleContainer}>
        <span className={styles.circle} />
        <span className={styles.circle} />
        <span className={styles.circle} />
      </span>
      <span className={styles.label}>{message}</span>
    </div>
  );
}
